angular.module('aprima-core-ui').component('apVisitBrief', {
    bindings: {
        visit: '<',
        showDuration: '<?'
    },
    transclude: true,
    templateUrl: '/core-ui/views/directives/partials/apVisitBrief.html',
    controller:['DateUtilities' , function(DateUtilities) {
        'use strict';

        this.$onInit = function init() {
            this.getDuration = DateUtilities.getDurationString;
        };
    }]
});